import { Paths } from 'src/constants/paths'

export type Auth0LogoutConfig = {
  auth0Domain: string | undefined
  auth0ClientId: string | undefined
  webDomain: string
}

export const getAuth0LogoutConfigFromEnv = (): Auth0LogoutConfig => ({
  auth0Domain: import.meta.env.VITE_AUTH0_DOMAIN,
  auth0ClientId: import.meta.env.VITE_AUTH0_CLIENT_ID,
  webDomain: import.meta.env.VITE_WEB_DOMAIN,
})

/**
 * Auth0のセッションを破棄するためのログアウトURLを組み立てる。
 * Auth0の設定が無い環境（段階導入中のstage2/dct）ではnullを返し、呼び出し側で現状動作にフォールバックする。
 *
 * Entraのセッションは意図的に残すため`federated`は付けない。
 * 残ったEntraセッションに対してAuth0接続の`prompt=select_account`がアカウント選択画面を出す。
 */
export const buildAuth0LogoutUrl = (
  config: Auth0LogoutConfig = getAuth0LogoutConfigFromEnv(),
): string | null => {
  const { auth0Domain, auth0ClientId, webDomain } = config

  if (!auth0Domain || !auth0ClientId) {
    return null
  }

  const returnTo = encodeURIComponent(`${webDomain}${Paths.Login}`)

  return `https://${auth0Domain}/v2/logout?client_id=${auth0ClientId}&returnTo=${returnTo}`
}
